<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix flex flex-b">
				<h4>基本信息</h4>
			</div>
			<el-form :model="addBody" :rules="rules" ref="addBody" label-width="0px" class="demo-ruleForm">
				<el-form-item label="核心技术标题" prop="title" :label-width="labelWidth">
					<el-input :disabled='viewFlag' style="width: 700px;" v-model="addBody.title"
						placeholder="请输入1-20位核心技术标题，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="核心技术简述" prop="detail" :label-width="labelWidth">
					<el-input :disabled='viewFlag' style="width: 700px;" v-model="addBody.detail" type="textarea" :rows='5'
						placeholder="请输入1-50位核心技术简述，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="核心技术权重" prop="weight" :label-width="labelWidth">
					<el-input :disabled='viewFlag' style="width: 700px;" v-model="addBody.weight" type="number"
						placeholder="请输入大于0的数字"></el-input>
					<div style="color: #999;">权重数字越大排序越靠前</div>
				</el-form-item>
				<el-form-item label="核心技术详情" prop="desc" :label-width="labelWidth">
					<div v-html="addBody.desc" v-if="viewFlag"></div>
					<QuillEditor :value="addBody.desc" v-else @input="editorInput"></QuillEditor>
				</el-form-item>
				<el-form-item label="图片" prop="img" :label-width="labelWidth">
					<img v-if="viewFlag" class="pointer"
						@click="viewImage(addBody.img.indexOf('http')!=-1? addBody.img:imgDomain+addBody.img)"
						:src="addBody.img.indexOf('http')!=-1? addBody.img:imgDomain+addBody.img" style="width: 150px;height: 150px;" />
					<ImageUpload v-else :limit='1' @input='imageUpload' :onloadImageList='onloadImageList'>
					</ImageUpload>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button @click="goBack()" style="width: 150px;">返 回</el-button>
			<el-button type="primary" style="width: 150px;" v-if="!viewFlag" @click="submitForm('addBody')">保 存</el-button>
		</el-card>

	</div>
</template>

<script>
	import QuillEditor from '@/components/quill-editor'
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import ImageUpload from "@/components/ImageUpload"
	import {
		addArt,
		getArtDetail,
		updateArt
	} from "@/api/views"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				editdialogVisible: false,
				labelWidth: '150px',
				radio: '2',
				activeTab: 'first',
				imgDomain,
				onloadImageList: [],
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value: '500',
				addBody: {
					title: '',
					detail: '',
					weight: '',
					desc: '',
					uuid:'',
					img:''
				},
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}, ],
					detail: [{
						required: true,
						message: '请输入简述',
						trigger: 'blur'
					}],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					},{
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					desc: [{
						required: true,
						message: '请输入详情',
						trigger: 'blur'
					}],
				},
				isEdit:false,
				viewFlag:false
			};
		},
		components: {
			CommonPagination,
			QuillEditor,
			ImageUpload
		},
		async mounted() {
			this.onloadImageList = []
			const uuid = this.$route.query.uuid
			this.viewFlag = this.$route.query.viewFlag
			if (uuid) {
				this.addBody.uuid = uuid
				this.isEdit = true
				this.getArtDetail(uuid);
			}
		},
		methods: {
			imageUpload(e) {
				this.addBody.img = imgDomain + e[0]
			},
			editorInput(e){
				this.addBody.desc = e
			},
			async getArtDetail(uuid){
				const {
					data,
					status
				} = await getArtDetail({
					uuid: uuid
				})
				if (status !== 200) return
				this.addBody = data.result
				this.onloadImageList.push(this.addBody.img)
			},
			async addArt(uuid){
				const {
					data,
					status
				} = await addArt(this.addBody)
				if (status !== 200) return
				this.$message.success('新增成功')
				this.goBack()
			},
			async updateArt(uuid){
				const {
					data,
					status
				} = await updateArt(this.addBody)
				if (status !== 200) return
				this.$message.success('修改成功')
				this.goBack()
			},
			addPointsDialog() {
				this.editdialogVisible = true
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if(!this.isEdit){
							this.addArt()
						}else{
							this.updateArt()
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			goBack() {
				this.$router.go(-1)
			},
			handleClickBack() {
				this.$router.back(-1);
			},


		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>